<script setup>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import "flatpickr/dist/flatpickr.css";
</script>
<template>
  <div class="card">
    <div class="card-header pb-0">
      <h6>รายชื่อ User</h6>
    </div>

    <div class="row">
      <form role="form">
        <div class="row">
          <div class="col-4 m-3">
            <input
              type="text"
              class="form-control"
              v-model="searchQuery"
              placeholder="ค้นหา Username, ชื่อ, หรือ นามสกุล"
            />
          </div>
        </div>
      </form>
    </div>

    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th
                v-for="column in columns"
                :key="column.id"
                class="text-uppercase text-xxs font-weight-bolder ps-2"
              >
                {{ column.name }}
              </th>
              <th class="text-uppercase text-xxs font-weight-bolder ps-2"></th>
            </tr>
          </thead>
          <tbody v-if="displayedData.length > 0">
            <tr v-for="(item, index) in displayedData" :key="index">
              <slot :row="item">
                <td
                  v-for="column in columns"
                  :key="column.id"
                  class="ms-auto text-wss"
                >
                  {{ itemValue(item, column.id, index) }}
                </td>
              </slot>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  // components: { DatePick },
  name: "l-table",
  // props: {
  //   columns: Array,
  //   data: Array
  // },
  data() {
    return {
      searchQuery: "",
      startRow: 0,
      rowsPerPage: 100,
      currentPage: 1,
      data: [],
      columns: [
        { id: "no", name: "No." },
        { id: "username", name: "username" },
        { id: "firstname", name: "ชื่อ" },
        { id: "lastname", name: "นามสกุล" },
        { id: "created_date", name: "วันที่สร้าง" },
        { id: "created_by", name: "สร้างโดย" },
        { id: "role", name: "สิทธิ์​" },
      ],
      username: "",
      isLoading: false,
      allBet: 0,
      allWinLoss: 0,
      agentList: [],
    };
  },
  created() {
    this.getData(this.username);
  },
  computed: {
    filteredData() {
      const query = this.searchQuery.trim().toLowerCase();
      return this.data.filter((item) => {
        const matchesSearch =
          !query ||
          ["username", "firstname", "lastname"].some((key) =>
            item[key]?.toLowerCase().includes(query)
          );

        const hasValidColumn = this.columns.some((column) =>
          this.hasValue(item, column.id)
        );

        return matchesSearch && hasValidColumn;
      });
    },

    displayedData() {
      return this.filteredData.slice(
        this.startRow,
        this.startRow + this.rowsPerPage
      );
    },
    totalPages() {
      return Math.ceil(this.filteredData.length / this.rowsPerPage);
    },
  },
  methods: {
    calculateSum(array, property) {
      const total = array.reduce((accumulator, object) => {
        return accumulator + Number(object[property]);
      }, 0);

      return total;
    },
    getData(username) {
      this.isLoading = true;
      if (username == "") {
        axios
          .get(`https://dashboard-api.linkstudio.io/api/v1/game/control/users/all`)

          // .post(`https://dashboard-api.linkstudio.io/api/v1/game/control/warrior/${startDate}/${endDate}`, { agent })
          .then((response) => {
            // JSON responses are automatically parsed.
            this.data = response.data.data.list;
            //   this.agentList = response.data.data.agent
            //  this.allBet =  this.calculateSum(this.data.filter(bet => bet.is_freespin == 0), 'bet_amount')
            //  this.allWinLoss = this.calculateSum(this.data, 'win_loss')
            this.isLoading = false;
          })
          .catch((e) => {
            console.log(e);
            this.isLoading = false;
          });
      } else if (username != "") {
        axios
          .post(
            `https://dashboard-api.linkstudio.io/api/v1/game/control/users`,
            { username }
          )
          // .post(`https://dashboard-api.linkstudio.io/api/v1/game/control/warrior/${startDate}/${endDate}`, { username })
          .then((response) => {
            // JSON responses are automatically parsed.
            this.data = response.data.data.list;
          })
          .catch((e) => {
            console.log(e);
            this.isLoading = false;
          });
      }
      this.currentPage = 1;
      this.startRow = 0;
    },
    hasValue(item, column) {
      return item[column.toLowerCase()] !== "undefined";
    },
    itemValue(item, columnId, index) {
    const value = item[columnId];

    if (columnId === 'created_date') {
      return this.formatDate(value);
    } else if (columnId == "no") {
        return index + 1 + this.startRow;
      }

    return value;
  },
     formatDate(isoString) {
    if (!isoString) return '';
    const date = new Date(isoString);

    const pad = (n) => n.toString().padStart(2, '0');

    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1);
    const year = date.getFullYear();
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  },
    previousPage() {
      if (this.startRow >= this.rowsPerPage) {
        this.startRow -= this.rowsPerPage;
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.startRow + this.rowsPerPage < this.filteredData.length) {
        this.startRow += this.rowsPerPage;
        this.currentPage++;
      }
    },
    goToPage(page) {
      this.startRow = (page - 1) * this.rowsPerPage;
      this.currentPage = page;
    },
  },
};
</script>
